import type {
	Gsoa_ShoppingList_GetAllShoppingLists_response as AllShoppingLists,
	Gsoa_ShoppingList_GetAllShoppingListsCollection as ShoppingList,
	Gsoa_ShoppingList_GetItems_response as ItemsResponse,
	Gsoa_ShoppingList_GetItemsCollection as GetItemsCollection,
	Gsoa_ShoppingList_UpdateItem as UpdateItem,
	Gsoa_ProductCatalog_ProductDetailForShoppingList as ProductDetailForShoppingList,
	Gsoa_ProductCatalog_ProductDetail as ProductDetail,
} from '~/openapi';

export const GUEST_SHOPPING_LISTS_KEY = 'guest-shopping-lists';
export const GUEST_MERGE_STATE_KEY = 'guest-shopping-lists-merge-state';
export const DEFAULT_GUEST_LIST_NAME = 'Nákupní seznam';
export const MAX_GUEST_LISTS = 10;
export const MAX_GUEST_ITEMS_PER_LIST = 200;
export const MAX_STORAGE_BYTES = 1_000_000;
export const SNAPSHOT_STALE_MS = 24 * 60 * 60 * 1000;

export type GuestMergeState = 'pending' | 'done' | 'dismissed';

export interface GuestProductSnapshot extends ProductDetailForShoppingList {
	fetchedAt?: string;
	houseNumber?: number;
	unavailable?: boolean;
}

export interface GuestShoppingListItem {
	ID: number;
	Code: string;
	Text: string;
	VANR?: string | null;
	Amount?: number | null;
	Purchased: boolean;
	GeneralizedProduct: boolean;
	LastUpdate: string;
	LastUpdateBy: 'guest';
	VisualOrder?: number | null;
	CreatedAt?: string;
}

export interface GuestShoppingList {
	ID: number;
	Name: string;
	ItemsCount: number;
	IsSelected: boolean;
	IsActive: false;
	ApplicationType: 'web-guest';
	CreatedAt?: string;
	gtmUuid?: string;
	items: GuestShoppingListItem[];
}

export interface GuestShoppingListsState {
	version: 1;
	idCounter: number;
	itemIdCounter: number;
	lists: GuestShoppingList[];
	lastModified: string;
}

export interface CreateItemPayload extends UpdateItem {
	snapshot?: GuestProductSnapshot;
	product?: ProductDetail;
}

export interface ShoppingListItemsEntry {
	id: number;
	products: ItemsResponse;
}

export interface ShoppingListRepository {
	fetchLists(force?: boolean): Promise<AllShoppingLists | null>;
	fetchItems(listId?: string, houseNumber?: number): Promise<ShoppingListItemsEntry[]>;
	createList(name: string): Promise<ShoppingList | null>;
	updateList(id: string, name: string, isSelected?: boolean): Promise<ShoppingList | null>;
	deleteList(id: string): Promise<boolean>;
	createItem(listId: string, item: CreateItemPayload): Promise<GetItemsCollection | null>;
	updateItem(listId: string, itemId: string, item: CreateItemPayload): Promise<GetItemsCollection | null>;
	deleteItem(listId: string, itemId: string): Promise<boolean>;
	clearItems(listId: string): Promise<boolean>;
	reorderItems(
		listId: string,
		orderedItemIds: number[],
		sourceItems?: GetItemsCollection[],
		houseNumber?: number,
	): Promise<void>;
	invalidateCache?(): void;
}

export class GuestShoppingListStorageError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'GuestShoppingListStorageError';
	}
}
